module.exports = __webpack_public_path__ + "img/square02.7925e241.png";